import React from 'react'

const LeftArrow = props => (
  <svg
    {...props}
    width='14px'
    height='23px'
    viewBox='0 0 14 23'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g
      id='Landing-Page'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'>
      <g
        id='INTERESTS'
        transform='translate(-302.000000, -94.000000)'
        fill='#D8D8D8'>
        <path
          d='M309.11149,108.24257 L299.86892,99 L298,100.86892 L307.24257,110.11149 L307.222981,110.13108 L309.091901,112 L320.118531,100.97337 L318.249611,99.1044492 L309.11149,108.24257 Z'
          id='Combined-Shape'
          transform='translate(309.059266, 105.500000) rotate(90.000000) translate(-309.059266, -105.500000) '
        />
      </g>
    </g>
  </svg>
)

export default LeftArrow



// WEBPACK FOOTER //
// ./src/svg-icons/LeftArrow.js